import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import ServiceCard from "../components/ServiceCard";
import { services } from "../data/services";

const Services = () => {
  return (
    <div data-testid="services-page">
      <section className="max-w-7xl mx-auto container-px pt-16 pb-10 md:pt-24">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.22em] text-primary font-semibold">Services</p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tight leading-[1.02]">
            Six ways in.
            <br />
            <span className="wave-underline">One warm welcome</span>.
          </h1>
          <p className="mt-6 text-lg text-foreground/70 max-w-2xl leading-relaxed">
            Tap any of our programs below to see what a typical session looks
            like, who it's for and how to get involved. Everything is flexible
            and NDIS-friendly.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto container-px pb-20 md:pb-28">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {services.map((s, i) => (
            <ServiceCard key={s.id} service={s} index={i} />
          ))}
        </div>

        <div className="mt-16 flex justify-center">
          <Button
            asChild
            data-testid="services-cta-contact"
            className="rounded-full bg-primary text-primary-foreground h-14 px-8 hover:-translate-y-0.5 transition-transform"
          >
            <Link to="/contact">
              Not sure which one fits? Chat with us
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Services;
